import React, { useEffect, useState } from "react";
import { Button, Row } from "react-bootstrap";
import Card from "src/components/Cards/Basic";
import FabPlateau from "src/components/UiComponents/Buttons/FabPlateau";
import IconButton from "src/components/IconButton";
import { euroFormatter } from "src/global";
import {
  faAdd,
  faPencil as PencilIcon,
  faTrash as DeleteIcon,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useModal from "src/components/Modal/hooks/useModal";
import ConfirmDeleteDialog from "src/components/Modal/ConfirmDelete";
import EditPayPerUseProductDialog from "./././././EditPayPerUseProductDialog";
import { showErrorToast, showSuccessToast } from "src/components/Toasts";
import axios from "src/config/axios";
import { useTranslation } from "react-i18next";

const PayPerUseSettingsPage = ({}) => {
  function handleEdit(payPerUsePrice) {
    setSelectedProduct(payPerUsePrice);
    toggleEdit();
  }

  function handleArchive(payPerUsePrice) {
    setSelectedProduct(payPerUsePrice);
    toggleArchive();
  }

  function handleCreate() {
    setSelectedProduct({});
    toggleEdit();
  }
  const [payPerUseProducts, setPayPerUseProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState({});
  const { isShow: showEdit, toggle: toggleEdit } = useModal();
  const { isShow: showArchive, toggle: toggleArchive } = useModal();
  const { t } = useTranslation("dashboard");

  useEffect(() => {
    loadPayPerUsePrices();
  }, []);

  const loadPayPerUsePrices = () => {
    axios
      .get(`/api/v1/pay_per_use_products.json`)
      .then(function (response) {
        setPayPerUseProducts(response.data.entries);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const archive = (payPerUse) => {
    axios
      .delete(`/api/v1/pay_per_use_products/${payPerUse.id}.json`)
      .then(function () {
        loadPayPerUsePrices();
        showSuccessToast();
      })
      .catch(function (error) {
        showErrorToast(error.response.data);
      });
  };

  const handleEdited = () => {
    toggleEdit();
    showSuccessToast();
    loadPayPerUsePrices();
  };

  const handleDelete = () => {
    archive(selectedProduct);
    toggleArchive();
  };

  return (
    <>
      <Card title={`Pay Per Use Produkte (${payPerUseProducts.length ?? 0})`}>
        <div className="table-responsive">
          <div className="ui-table-container">
            <table
              className="table table-bordered"
              id="dataTable"
              width="100%"
              cellSpacing="0"
            >
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Minuten</th>
                  <th>Preis</th>
                  <th>Optionen</th>
                </tr>
              </thead>
              <tbody>
                {payPerUseProducts.map((payPerUsePrice) => {
                  return (
                    <tr key={payPerUsePrice.id}>
                      <td>{payPerUsePrice.name}</td>
                      <td>{payPerUsePrice.duration_in_seconds / 60}</td>
                      <td>
                        {payPerUsePrice.price &&
                          euroFormatter(payPerUsePrice.price)}
                      </td>
                      <td>
                        <IconButton
                          className="mr-1 bg-transparent border-0 mr-3"
                          textColor="var(--primary)"
                          icon={PencilIcon}
                          onClick={() => handleEdit(payPerUsePrice)}
                        />
                        <IconButton
                          className="mr-2 mr-3 bg-transparent border-0"
                          textColor="var(--danger)"
                          icon={DeleteIcon}
                          onClick={() => handleArchive(payPerUsePrice)}
                        />
                      </td>
                    </tr>
                  );
                })}
                {payPerUseProducts.length === 0 && (
                  <tr>
                    <td>{t("common:components.table.noEntries")}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <Row className="justify-content-end mr-2 mt-5">
          <FabPlateau>
            <Button
              className="float-right p-2 pl-3 pr-3"
              variant="primary"
              onClick={handleCreate}
            >
              <FontAwesomeIcon icon={faAdd} />
              &nbsp;
              {t("common:components.button.new")}
            </Button>
          </FabPlateau>
        </Row>
      </Card>
      {showEdit && (
        <EditPayPerUseProductDialog
          toggle={toggleEdit}
          payPerUsePrice={selectedProduct}
          handleSuccess={handleEdited}
        />
      )}
      <ConfirmDeleteDialog
        show={showArchive}
        handleClose={toggleArchive}
        handleDelete={handleDelete}
      />
    </>
  );
};

export default PayPerUseSettingsPage;
